import { render, staticRenderFns } from "./USToDoorPage.vue?vue&type=template&id=3b80f70b&scoped=true"
import script from "./USToDoorPage.vue?vue&type=script&lang=js"
export * from "./USToDoorPage.vue?vue&type=script&lang=js"
import style0 from "./USToDoorPage.vue?vue&type=style&index=0&id=3b80f70b&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b80f70b",
  null
  
)

export default component.exports